import React, { useState } from 'react'
import ConfirmationDialog from 'core/components/ConfirmationDialog'
import { getDeleteConfirmText } from 'core/components/CRUDListContainer'
import useUpdateAction from 'core/hooks/useUpdateAction'
import { updateNodePools } from '../kaapi/clusters/actions'
import { getDeleteText } from './DeleteWorkerNodesDialog'

const DeleteNodeGroupsDialog = ({
  rows,
  onClose,
  isLastRunningNode,
  reloadMachineDeployments,
  cluster,
}) => {
  const [error, setError] = useState(null)

  const {
    update: updateNodePool,
    updating: updatingNodePools,
    error: updateNodePoolsError,
  } = useUpdateAction(updateNodePools)

  const deleteConfirmText = getDeleteConfirmText(rows.flatMap((nodeGroup) => nodeGroup.metadata))
  const deleteConfirmTextWithDisclaimer = getDeleteText(deleteConfirmText, isLastRunningNode)

  const handleSubmit = async () => {
    const promises = []
    for (const nodeGroup of rows) {
      if (!nodeGroup?.kind) continue
      const nodeIndex = cluster?.spec?.topology?.workers?.machineDeployments?.findIndex(
        (md) =>
          md?.name === nodeGroup?.metadata?.labels?.['topology.cluster.x-k8s.io/deployment-name'],
      )

      if (nodeIndex === undefined || nodeIndex === -1) {
        console.error('Node deployment not found in cluster topology')
        continue
      }

      // Delete the node pool
      promises.push(
        updateNodePool({
          namespace: nodeGroup.metadata.namespace,
          body: [
            {
              op: 'remove',
              path: `/spec/topology/workers/machineDeployments/${nodeIndex}`,
            },
          ],
          clusterName: cluster?.metadata?.name,
        }),
      )
    }

    if (promises.length === 0) {
      setError({
        title: 'No Deletable Node Groups',
        message:
          'Selected node groups could not be found in cluster topology. Please verify labels match topology deployment names.',
      })
      return
    }

    // Wait for all promises to resolve
    try {
      await Promise.all(promises)
      reloadMachineDeployments(true)
      onClose(true)
    } catch (err) {
      console.error(err)
      setError({ title: 'Error Deleting Node Group', message: err?.message })
    }
  }

  return (
    <ConfirmationDialog
      text={deleteConfirmTextWithDisclaimer}
      onConfirm={handleSubmit}
      onCancel={onClose}
      error={error || updateNodePoolsError}
      loading={updatingNodePools}
      open
      data-testid="delete-node-groups-dialog"
    />
  )
}

export default DeleteNodeGroupsDialog
